import { render, staticRenderFns } from "./diffLabelValue.vue?vue&type=template&id=8c32fb5a"
import script from "./diffLabelValue.vue?vue&type=script&lang=js"
export * from "./diffLabelValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports